export default __webpack_public_path__ + "static/NBInternationalPro-Bold-54e979cc916be9c41ee2b063122c0146.otf";